"use strict";'use strict';

var chunkZMWIDAZG_js = require('./chunk-ZMWIDAZG.js');
require('./chunk-G6GVGCKL.js');



module.exports = chunkZMWIDAZG_js.Hotel_default;
